import React, { Component } from 'react';



const Contact=()=>{
    return(
        <div className='ninetyPer'>
            <h1>THis is the Contact PAGE</h1>
            <p>This is Contact page para</p>
        </div>
        
    )
}

export default Contact
